import { render, staticRenderFns } from "./ScientistSlots.vue?vue&type=template&id=13c844c4&scoped=true&"
import script from "./ScientistSlots.vue?vue&type=script&lang=js&"
export * from "./ScientistSlots.vue?vue&type=script&lang=js&"
import style0 from "./ScientistSlots.vue?vue&type=style&index=0&id=13c844c4&scoped=true&lang=scss&"
import style1 from "./ScientistSlots.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ScientistSlots.vue?vue&type=style&index=2&id=13c844c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c844c4",
  null
  
)

export default component.exports